import React from "react"
import { Helmet } from "react-helmet"
import ogp from "../images/ogp.png"

const Head = () => {
  return (
    <>
      <Helmet>
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-D7XL4ERNHC"
        ></script>
        <script>
          {`
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-D7XL4ERNHC');
  `}
        </script>

        <title>世界で唯一のオリジナル塩作りませんか？|さかたの塩</title>
        {/* ogp */}
        <meta
          name="description"
          content="ワインの澱、酒粕、醤油の澱が、唯一無二のオリジナル塩に変わります。新しい商品として、販促品としてお使い頂けます。"
        />
        <meta
          property="og:title"
          content="世界で唯一のオリジナル塩作りませんか？|さかたの塩"
        />
        <meta
          property="og:description"
          content="ワインの澱、酒粕、醤油の澱が、唯一無二のオリジナル塩に変わります。新しい商品として、販促品としてお使い頂けます。"
        />
        <meta property="og:url" content="https://sakatanoshio-e35c6.web.app" />
        <meta property="og:image" content={ogp} />
        <meta
          name="twitter:card"
          content=" 世界で唯一のオリジナル塩作りませんか？|さかたの塩"
        />
        <meta property="og:type" content="website" />
        <meta name="google" content="notranslate" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
    </>
  )
}

export default Head
